module.exports = __webpack_public_path__ + "img/3A.8c1e823e.jpeg";